import Title from "../components/Title";
import WorkCard from "../components/WorkCard";

export default function Work() {
    return (
        <>
            <section id="work" className="work-section">
                <div className="work-container">
                    <div style={{ alignSelf: 'end' }}>
                        <Title headingLevel={2} size="L" className="work-title">
                            Recent <i>Work</i>
                        </Title>
                    </div>
                    <div className="work-grid">

                        <WorkCard label="ADOBE" color="red" to="/adobe">
                            <img src="/images/adobe-logo-white.png" alt="" width="126" height="175" style={{ maxWidth: '100%', height: 'auto' }} />
                        </WorkCard>

                        <WorkCard label="ORGANISE" color="purple" to="/organise">
                            <img src="/images/organise-logo-white.png" alt="" width="176" height="107" style={{ maxWidth: '100%', height: 'auto' }} />
                        </WorkCard>

                        <WorkCard label="VAULT" color="teal" to="/vault">
                            <img src="/images/vault-logo-white.png" alt="" width="176" height="58" style={{ maxWidth: '100%', height: 'auto' }} />
                        </WorkCard>

                        <WorkCard label="DELOITTE DIGITAL" color="green" to="/deloitte">
                            <img src="/images/deloitte-logo-white.png" alt="" width="176" height="82" style={{ maxWidth: '100%', height: 'auto' }} />
                        </WorkCard>
                    </div>


                </div>
            </section>
        </>
    );
}

